import { useContext } from 'react';
import { Card, Typography } from 'antd';
import { IGiveaway } from '../../../../../interfaces';
import { WinnersCard } from '../WinnersCard';
import { ThemeContext } from '../../../../../contexts/ThemeContext';

const { Title } = Typography;

interface IProps {
    canViewWinners: boolean;
    giveawayData: IGiveaway;
    offset?: number;
}

export default function AwardsSection({ giveawayData, canViewWinners, offset }: IProps) {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === 'dark';

    const ITEMS_PER_PAGE = 4;
    const CURRENT_PAGE = 1;

    const awards = giveawayData?.awards || [];
    const OFFSET = offset ?? 3;

    const currentItems = awards.slice(
        OFFSET + (CURRENT_PAGE - 1) * ITEMS_PER_PAGE,
        OFFSET + CURRENT_PAGE * ITEMS_PER_PAGE
    );

    if (currentItems.length === 0) {
        return null;
    }

    const cardContainerStyle = {
        borderRadius: 12,
        padding: 0,
        marginBottom: 16,
        background: isDark ? '#141414' : '#ffffff',
        border: `1px solid ${isDark ? '#262626' : '#eaedf1'}`,
        boxShadow: isDark
            ? '0 4px 20px rgba(0, 0, 0, 0.35)'
            : '0 2px 10px rgba(0, 0, 0, 0.03)',
    };

    return (
        <div className='page'>
            <div className="line-divider" style={{ display: 'none' }} />
            <Card
                className='section-report report-card'
                style={cardContainerStyle}
                bodyStyle={{ padding: '16px 20px' }}
            >
                <Title
                    level={5}
                    className="section-title"
                    style={{
                        fontWeight: 600,
                        color: isDark ? '#f1f5f9' : '#0f172a',
                        marginBottom: 14,
                    }}
                >
                    Demais Prêmios {canViewWinners && 'e Ganhadores'}
                </Title>

                <WinnersCard canViewWinners={canViewWinners} awards={currentItems} />
            </Card>
        </div>
    );
}